// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.GridViewStyleUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { assign } from 'lodash/fp';

/**
 * Build position style
 * @param {any} position
 */
function getPositionStyle(position: any) {
  return {
    left: position.left,
    top: position.top,
    width: position.width,
    height: position.height,
    position: 'absolute'
  };
}

/**
 * Build style with display
 * @param {any} style 
 * @param {boolean} display 
 */
function styleWithDisplay(style: any, display: boolean) {
  return assign(style, {
    display: display ? 'block' : 'none'
  });
}

/**
 * Transform to full size style
 * @param {any} style 
 */
function transformToFullSizeStyle(style: any) {
  return {
    position: 'absolute',
    width: style.width,
    height: style.height,
    top: style.top,
    left: style.left,
    transform: `rotateY(${180 - style.rotate}deg)`,
    WebkitTransform: `rotateY(${180 - style.rotate}deg)`,
    transformStyle: 'preserve-3d',
    zIndex: 1
  };
}

/**
 * Transform To default style
 * @param {any} style 
 * @param {boolean} needRotate 
 * @param {boolean} doesBreakPage 
 * @param {boolean} printingMode 
 * @param {any} autoSize 
 * @param {boolean} isFirstItem 
 */
function transformToDefaultStyle(
  style: any,
  needRotate: boolean,
  doesBreakPage: boolean,
  printingMode: boolean,
  autoSize: any,
  isFirstItem: boolean
) {
  if (printingMode) {
    return {
      position: !doesBreakPage ? 'absolute' : 'initial',
      top: !doesBreakPage ? style.top : null,
      left: !doesBreakPage ? style.left : null,
      width: !doesBreakPage ? style.width : null,
      height: !doesBreakPage ? style.height : null,
      pageBreakInside: !isFirstItem ? 'avoid' : null
    };
  }

  return {
    position: 'absolute',
    width: style.width,
    height: style.height,
    top: style.top,
    left: style.left,
    transform: needRotate ? null : `rotateY(${style.rotate}deg)`,
    WebkitTransform: needRotate ? null : `rotateY(${style.rotate}deg)`,
    transformStyle: needRotate ? 'flat' : 'preserve-3d',
    zIndex: 0
  };
}

export default {
  getPositionStyle: getPositionStyle,
  styleWithDisplay: styleWithDisplay,
  transformToFullSizeStyle: transformToFullSizeStyle,
  transformToDefaultStyle: transformToDefaultStyle
};



// WEBPACK FOOTER //
// ./ui/share/components/controls/GridLayout/Izenda.GridViewStyleUtils.js